import { render, staticRenderFns } from "./ProductCardShopLook.vue?vue&type=template&id=09993506&"
import script from "./ProductCardShopLook.vue?vue&type=script&lang=js&"
export * from "./ProductCardShopLook.vue?vue&type=script&lang=js&"
import style1 from "./ProductCardShopLook.vue?vue&type=style&index=1&id=09993506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WishListBtn: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/WishListBtn.vue').default,ProductCardTop: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardTop.vue').default,ProductCardSizes: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardSizes.vue').default,SizeGuide: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/SizeGuide.vue').default})
